const config = {
  API_URL: "https://www.dtensk.org/admin/api/Masterdata/",
  API_KEY: "UGFzaHV2YWlkeWFAMjAyMQ==",
};

export default config;
